import { Routes } from '@angular/router';

export const ROUTES: Routes = [
	{ path: '**', redirectTo: 'shell' }
];



// WEBPACK FOOTER //
// /Users/sofia/Documents/ng2-portals/ng2-firebase-toolkit-admin/src/app/app.routes.ts